import { Box, Drawer } from "@mui/material";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { setOpen } from "@store/sideBarSlice";
import SideBar from "@components/SideBar/SideBar";

const MenuDrawer: FC = () => {
  const open = useSelector((state: RootState) => state.drawer.open);
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(setOpen(false));
  };

  return (
    <Drawer open={!!open} onClose={onClose}>
      <Box minHeight="64px"></Box>
      <SideBar onNavigate={onClose} />
    </Drawer>
  );
};

export default MenuDrawer;
